import {Component, Inject} from "@angular/core";
import {MSAL_GUARD_CONFIG, MsalGuardConfiguration, MsalService} from "@azure/msal-angular";
import {RedirectRequest} from "@azure/msal-browser";

@Component({
  selector: 'app-start-page',
  templateUrl: './start-page.component.html',
  styleUrls: ['./start-page.component.scss'],
})
export class StartPageComponent {

  readonly currentYear = new Date().getFullYear();

  constructor(private msalService: MsalService, @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration) {}

  login() {
    this.msalService.loginRedirect({
      ...this.msalGuardConfig.authRequest,
      redirectStartPage: '/orders',
    } as RedirectRequest);
  }
}
